import Vue from 'vue'
import Router from 'vue-router'
import VueCookie from 'vue-cookie'
import top from '../components/top.vue'
import concept from '../components/concept.vue'
import newsTop from '../components/news_top.vue'

Vue.use(Router)
Vue.use(VueCookie)

const router = new Router({
  base: '/',
  mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ selector: to.hash, behavior: 'smooth' })
        }, 800)
      })
    }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/index.html',
      name: 'top-index',
      component: top
    },
    {
      path: '/',
      name: 'top',
      component: top
    },
    {
      path: '/concept',
      name: 'concept',
      component: concept
    },
    {
      path: '/news',
      name: 'news-top',
      component: newsTop
    },
    {
      path: '*',
      name: 'notfound',
      redirect: '/'
    }
  ]
})

// const basicAuth = () => (to, from, next) => {
//   const DIGESTKEY = process.env.DIGEST_KEY
//   if (to.matched.some(record => record.meta.requireAuth)) {
//     if (VueCookie.get('input_id') !== sha256.hmac(DIGESTKEY, process.env.BASIC_ID) ||
//       VueCookie.get('input_pass') !== sha256.hmac(DIGESTKEY, process.env.BASIC_PASS)) {
//       next({
//         path: '/login'
//       })
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// }
//
// router.beforeEach(basicAuth())

export default router
